import type { SkillSummary, UserWorkflowsResult } from '@heidi/agents/contracts';
import {
  mapUserWorkflows,
  rpaUserWorkflowsQueryKey,
  shouldPollUserWorkflows,
} from '@heidi/agents/contracts';
import { useQuery } from '@tanstack/react-query';
import { fetchAllWorkflowsJson } from '../api/rpa-recordings-http';

const POLL_INTERVAL_MS = 5_000;
const STALE_TIME_MS = 30_000;

export function useUserWorkflows({
  enabled = true,
  keepPollingWhile,
}: {
  enabled?: boolean;
  /** Extra poll condition, checked against each fetched summary list. */
  keepPollingWhile?: (personal: readonly SkillSummary[]) => boolean;
} = {}) {
  return useQuery<UserWorkflowsResult>({
    enabled,
    queryKey: rpaUserWorkflowsQueryKey,
    queryFn: async () => mapUserWorkflows(await fetchAllWorkflowsJson()),
    staleTime: STALE_TIME_MS,
    refetchOnMount: 'always',
    refetchInterval: (query) => {
      const personal = query.state.data?.personal;
      const keepPolling = keepPollingWhile?.(personal ?? []) ?? false;
      return keepPolling || shouldPollUserWorkflows(personal) ? POLL_INTERVAL_MS : false;
    },
  });
}
